<script setup>
  import { onMounted, ref } from 'vue';

  const inputRef = ref(null);

  const props = defineProps({
    name: {
      default: '',
      type: String,
    },

    label: {
      default: '',
      type: String,
    },

    id: {
      type: String,
    },

    class: {
      type: String,
    },

    readonly: {
      type: Boolean,
    },

    disabled: {
      type: String,
    },

    src: {
      default: '',
      type: String,
    },

    required: {
      type: Boolean,
    },
  });

  function handleInput(event) {
    event.target.setAttribute('data-value', event.target.value);
  }

  onMounted(() => {
    /**
     * Dá pra refatorar pra Vue, mas fica pra depois
     */
    document.querySelectorAll('.drop-zone__input').forEach(inputElement => {
      const dropZoneElement = inputElement.closest('.drop-zone');

      inputElement.addEventListener('change', event => {
        if (inputElement.files.length) {
          updateThumbnail(dropZoneElement, inputElement.files[0]);
        }
      });

      dropZoneElement.addEventListener('dragover', event => {
        // This along with prevDef in drop event prevent browser from opening file in a new tab
        event.preventDefault();
        dropZoneElement.classList.add('drop-zone--over');
      });

      ['dragleave', 'dragend'].forEach(type => {
        dropZoneElement.addEventListener(type, event => {
          dropZoneElement.classList.remove('drop-zone--over');
        });
      });

      dropZoneElement.addEventListener('drop', event => {
        event.preventDefault();

        /**
         * If you console.log only event and check the same data location,
         * you won't see the file due to a chrome bug!
         */
        if (event.dataTransfer.files.length) {
          // Asigns dragged file to inputElement
          inputElement.files = event.dataTransfer.files;

          // Thumbnail will only show first file if multiple files are selected
          updateThumbnail(dropZoneElement, event.dataTransfer.files[0]);
        }

        dropZoneElement.classList.remove('drop-zone--over');
      });
    });

    function updateThumbnail(dropZoneElement, file) {
      let thumbnailElement = dropZoneElement.querySelector('.drop-zone__thumb');

      /*remove text prompt*/
      if (dropZoneElement.querySelector('.drop-zone__prompt')) {
        dropZoneElement.querySelector('.drop-zone__prompt').remove();
      }

      /*first time there won't be a thumbnailElement so it has to be created*/
      if (!thumbnailElement) {
        thumbnailElement = document.createElement('div');
        thumbnailElement.classList.add('drop-zone__thumb');
        dropZoneElement.appendChild(thumbnailElement);
      }

      /*takes file name and sets it as dataset label so css can display it*/
      thumbnailElement.dataset.label = '✅';

      /*show thumbnail for images*/
      if (file.type.startsWith('image/')) {
        const reader = new FileReader(); /*lets us read files to data URL*/
        reader.readAsDataURL(file); /*base 64 format*/
        reader.onload = () => {
          const image = new Image();
          image.src = reader.result;
          
          image.onload = () => {
            if (image.width < 512 || image.height < 512 || image.width != image.height) {
              thumbnailElement.dataset.label = 'Dimensões Erradas';

              inputRef.value.dataset.value = '';
              inputRef.value.value = '';
            }
          }

          if (file.size > 5120000) {
            thumbnailElement.dataset.label = 'Tamanho Máximo 5MB';

            inputRef.value.dataset.value = '';
            inputRef.value.value = '';
          }

          if (file.type != 'image/jpeg' && file.type != 'image/jpg' && file.type != 'image/png') {
            thumbnailElement.dataset.label = 'Formato Inválido';

            inputRef.value.dataset.value = '';
            inputRef.value.value = '';
          }
          
          thumbnailElement.style.backgroundImage = `url('${reader.result}')`; /*asynchronous call. This function runs once reader is done reading file. reader.result is the base 64 format*/
          thumbnailElement.style.backgroundPosition = 'center';
        };
      } else {
        thumbnailElement.style.backgroundImage =
          null; /*plain background for non image type files*/
      }
    }
  });
</script>

<template>
  <label :class="props.readonly ? `pointer-events-none` : ``">
    <span>{{ props.label }}</span>
    <span v-if="props.required" class="text-[red] font-bold">*</span>

    <div class="drop-zone">
      <div>
        <img
          class="drop-zone__prompt"
          :src="props.src"
          v-if="props.src != ''"
        />
        <div class="drop-zone__prompt" v-else>
          Clique ou solte sua imagem aqui
        </div>
      </div>
      <!-- <div class="drop-zone__thumb" data-label="myfile.txt"></div> -->
      <input
        type="file"
        class="drop-zone__input"
        accept="image/png, image/jpg, image/jpeg"
        :id="props.id"
        :name="props.name"
        :class="props.class"
        :title="props.label"
        :value="props.value"
        :readonly="props.readonly && props.readonly"
        :disabled="props.disabled && props.disabled"
        :data-value="props.src"
        :required="props.required && props.required"
        @input="handleInput($event)"
        ref="inputRef"
      />
      <!-- add multiple attribute to input to support uploading more than one file-->
    </div>
  </label>
</template>

<style>
  .drop-zone {
    max-width: 200px; /*max to make it responsive*/
    height: 200px;
    padding: 10px;
    display: flex;
    align-items: center;
    justify-items: center;
    text-align: center;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    font-weight: 500;
    font-size: 20px;
    cursor: pointer;
    color: lightgrey;
    border: 4px dashed rgb(218, 100, 100);
    border-radius: 10px;
  }
  .drop-zone--over {
    border-style: solid;
  }
  .drop-zone__input {
    display: none;
  }
  .drop-zone__thumb {
    width: 100%;
    height: 100%;
    border-radius: 10px;
    overflow: hidden;
    background-color: transparent;
    background-size: contain;
    background-repeat: no-repeat;
    position: relative;
  }
  .drop-zone__thumb::after {
    content: attr(data-label); /*  displays text of data-lable*/
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 5px 0;
    color: red;
    background: rgba(0, 0, 0, 0.75);
    text-align: center;
    font-size: 14px;
  }
</style>
